import {
  getOnDate,
  getOnTime,
  getUpcoming,
  getUpcomingToday,
} from '$tablet-app/src/app/calendar/common/actions';
import { createCalendarChatItem } from '$tablet-app/src/app/chat/ChatItem/functions';
import { ChatItem } from '$tablet-app/src/app/chat/ChatItem/types';
import {
  CalendarItemUnion,
  listCalendarItemsByHabitat,
} from '@akin-home/calendar/combined';
import { addDays, endOfDay, startOfDay } from 'date-fns';
import {
  CommandTypes,
  ShowCalendarItemCommand,
  ShowCalendarItemsCommand,
  ShowCalendarItemsTodayCommand,
} from '../types';

/** APIS for fetching and updating calendar items */
const handleCalendarItemCommand = async (
  command:
    | ShowCalendarItemCommand
    | ShowCalendarItemsTodayCommand
    | ShowCalendarItemsCommand,
  {
    addItem,
    habitatID,
  }: {
    addItem: (item: ChatItem | ChatItem[]) => void;
    habitatID: string;
  }
): Promise<string> => {
  const { data } = command;

  if (!data) return '';

  const types = data.type && [data.type];
  const start = data.date ? new Date(data.date) : new Date();

  const all_items = await listCalendarItemsByHabitat({
    types,
    query: {
      habitatID,
      filter: {
        mealType: data.mealType,
        title: data.title,
        from: startOfDay(start).toISOString(),
        to: endOfDay(addDays(start, 1)).toISOString(),
      },
    },
  });

  const upcoming_items = getUpcoming(all_items);

  const subsetNitems = data.number && Number(data.number) > 0;

  /** If showing what's left for today */
  if (command.type === CommandTypes.SHOW_CALENDAR_ITEMS_TODAY) {
    let filtered_items = getUpcomingToday(all_items);

    filtered_items = data.time
      ? getOnTime(filtered_items, data.time, true)
      : filtered_items;

    filtered_items = subsetNitems
      ? filtered_items.slice(0, Number(data.number))
      : filtered_items;

    if (!filtered_items.length) {
      return 'Nothing scheduled for today';
    }

    addItem(
      createCalendarChatItem({
        items: filtered_items.map((item) => ({
          item_id: item.id,
          type: item.type,
        })),
      })
    );
  } else if (
    command.type === CommandTypes.SHOW_CALENDAR_ITEM &&
    upcoming_items.length > 0
  ) {
    let item: CalendarItemUnion | undefined = upcoming_items[0];

    if (data.title) {
      item = all_items.find(
        (item) => item.title.toLowerCase() === data.title?.toLowerCase()
      );
    }

    if (item) {
      addItem(
        createCalendarChatItem({
          items: [
            {
              item_id: item.id,
              type: item.type,
            },
          ],
        })
      );

      return '';
    }
  } else if (command.type === CommandTypes.SHOW_CALENDAR_ITEMS && data.date) {
    const filtered_by_date = getOnDate(all_items, new Date(data.date));

    const filtered_items =
      data.time && data.time !== '$<time>'
        ? getOnTime(filtered_by_date, data.time, true)
        : filtered_by_date;

    if (!filtered_items.length) {
      return 'Nothing scheduled for then';
    }

    const top_filtered_items = subsetNitems
      ? filtered_items.slice(0, Number(data.number))
      : filtered_items;

    addItem(
      createCalendarChatItem({
        items: top_filtered_items.map((item) => ({
          item_id: item.id,
          type: item.type,
        })),
      })
    );
    return '';
  }

  return 'Nothing scheduled for then';
};

export default handleCalendarItemCommand;
